import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge, Input, Button } from 'reactstrap'
import { saveOrgMapping, deleteOrgMapping } from '../actions/threatlockerReconActions'

const OrgMappingModal = ({ isOpen, toggle, companyId, companyName }) => {
  const dispatch = useDispatch()
  const unmappedOrgs = useSelector((state) => state.threatlockerRecon.unmappedOrgs)
  const report = useSelector((state) => state.threatlockerRecon.report)
  const [searchText, setSearchText] = useState('')

  // Read mapped orgs from live report state so it updates after add/remove
  const currentRow = report?.find((r) => r.companyId === companyId)
  const mappedOrgs = currentRow?.mappedOrgs || []

  const filteredOrgs = (unmappedOrgs || []).filter((org) =>
    org.displayName?.toLowerCase().includes(searchText.toLowerCase()) ||
    org.identifier?.toLowerCase().includes(searchText.toLowerCase())
  )

  const handleAdd = (org) => {
    dispatch(saveOrgMapping(org.identifier, companyId))
    setSearchText('')
  }

  const handleRemove = (orgId) => {
    dispatch(deleteOrgMapping(orgId))
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        TL Organization Mapping - {companyName}
      </ModalHeader>
      <ModalBody>
        {/* Current mappings */}
        <h6>Mapped Organizations</h6>
        {(!mappedOrgs || mappedOrgs.length === 0) ? (
          <p className="text-muted small">No organizations mapped to this company.</p>
        ) : (
          <div className="mb-3">
            {mappedOrgs.map((org) => (
              <div
                key={org.threatlockerOrgId}
                className="d-flex justify-content-between align-items-center border rounded p-2 mb-1"
              >
                <div>
                  <strong>{org.threatlockerOrgName}</strong>
                  <small className="text-muted ms-2">({org.deviceCount} devices)</small>
                </div>
                <Button
                  size="sm"
                  color="outline-danger"
                  onClick={() => handleRemove(org.threatlockerOrgId)}
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>
        )}

        {/* Add new mapping */}
        <hr />
        <h6>Add Organization</h6>
        <Input
          type="text"
          placeholder="Search unmapped organizations..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="mb-2"
        />
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {searchText.length === 0 ? (
            <p className="text-muted small">Start typing to search...</p>
          ) : filteredOrgs.length === 0 ? (
            <p className="text-muted small">No unmapped organizations match your search.</p>
          ) : (
            filteredOrgs.slice(0, 20).map((org) => (
              <div
                key={org.identifier}
                className="d-flex justify-content-between align-items-center border rounded p-2 mb-1"
                style={{ cursor: 'pointer' }}
                onClick={() => handleAdd(org)}
              >
                <div>
                  <span>{org.displayName}</span>
                  <Badge color="secondary" className="ms-2">{org.computerCount} devices</Badge>
                </div>
                <small className="text-primary">+ Add</small>
              </div>
            ))
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  )
}

export default OrgMappingModal
